import { Button, Icon } from '../atoms'

export type MapType = 'osm' | 'satellite' | 'terrain' | 'dark'

export interface MapTypeSelectorProps {
  currentType: MapType
  onChange: (type: MapType) => void
}

const mapTypes: Array<{ type: MapType; label: string; icon: 'map' | 'satellite' | 'mountain' | 'moon' }> = [
  { type: 'osm', label: 'Standard', icon: 'map' },
  { type: 'satellite', label: 'Satellite', icon: 'satellite' },
  { type: 'terrain', label: 'Terrain', icon: 'mountain' },
  { type: 'dark', label: 'Dark', icon: 'moon' },
]

export const MapTypeSelector = ({
  currentType,
  onChange,
}: MapTypeSelectorProps) => {
  return (
    <div className="flex gap-1 sm:gap-1.5 p-1 bg-background-elevated rounded-lg border border-border">
      {mapTypes.map(({ type, label, icon }) => (
        <Button
          key={type}
          onClick={() => onChange(type)}
          variant={currentType === type ? 'primary' : 'secondary'}
          size="sm"
          className="flex-1 flex items-center justify-center gap-1.5 py-1.5 sm:py-2 min-h-[36px] sm:min-h-[40px] touch-manipulation"
          title={`Switch to ${label} map view`}
          aria-label={`Switch to ${label} map view`}
        >
          <Icon name={icon} className="w-4 h-4 sm:w-5 sm:h-5" />
        </Button>
      ))}
    </div>
  )
}
